module.exports = __webpack_public_path__ + "img/filled-ticket-now.ad77b9e9.svg";